<template>
  <v-container fluid class="px-0" id="listado-entregas">

    <!-- ══════════════════════════════════════════════════════
         HEADER — Desktop: tabla de 6 cols | Mobile: botón filtros
         ══════════════════════════════════════════════════════ -->

    <!-- DESKTOP HEADER -->
    <v-card class="mb-2 py-1 listing-header-card hidden-xs-only">
      <v-card-text class="header-table-card py-2">
        <div class="d-flex align-center justify-end flex-wrap mb-2" style="gap: 10px;">
          <v-btn dark x-small color="#2D4B95" @click="$store.entregaStore.commit('setEntregaConfigModal', true)">
            <v-icon small class="mr-1">mdi-cog</v-icon>
            <p class="mb-0">Configurar</p>
          </v-btn>
          <v-btn dark x-small color="#2D4B95" :loading="loadingExport" :disabled="loadingExport" @click="excelExport()">
            <v-icon small class="mr-1">mdi-microsoft-excel</v-icon>
            <p class="mb-0">Exportar a Excel</p>
          </v-btn>
					<div class="icon-top total">
						<span>Total: {{$store.entregaStore.state.listadoEntrega.total_entrega}}</span>
					</div>
        </div>
        <v-row no-gutters>

          <!-- Col 1: Toggle orden -->
          <v-col cols="1">
            <v-btn
              text
              class="table-header-button d-flex flex-row pa-0 justify-center"
              block
              style="height: auto;"
              @click="toggleOrder"
            >
              <v-icon color="#5e85ef" small class="mr-1">{{ getIconOrder }}</v-icon>
              <p class="mb-0 font-weight-bold body-2 text-capitalize">{{ getNameOrder }}</p>
            </v-btn>
          </v-col>

          <!-- Col 2: Entrega / Ubicación / Documentos (fusionadas) -->
					<v-col cols="4">
						<v-menu v-model="numeroMenu" :offset-y="true" :close-on-content-click="false" max-width="320px">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									text
									class="table-header-button d-flex flex-row pa-0 justify-start"
									block
									style="height: auto;"
									v-bind="attrs"
									v-on="on"
								>
									<p class="mb-0 font-weight-bold body-2 text-capitalize">Entrega / Ubicación / Plano</p>
									<v-icon color="#5e85ef" small class="ml-1">mdi-plus-circle</v-icon>
								</v-btn>
							</template>

							<v-card style="min-width: 280px; max-width: 320px;">
								<v-card-text class="pa-2">
									<v-expansion-panels accordion flat>

										<!-- Especialidad -->
										<v-expansion-panel>
											<v-expansion-panel-header style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;" class="py-2 px-3 mb-1">
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Especialidad</span>
													<v-chip x-small color="#2D4B95" dark v-if="specialtyFilter && specialtyFilter.length > 0" class="mr-4">
														{{ specialtyFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="specialtyFilter">
													<v-list-item dense style="min-height: auto;"
														v-for="(specialty, index) in $store.projectsStore.state.selectedProject.specialties"
														:key="'specialty_filter_' + index"
														:value="specialty.id"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ specialty.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Nivel -->
										<v-expansion-panel>
											<v-expansion-panel-header style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;" class="py-2 px-3 mb-1">
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Nivel</span>
													<v-chip x-small color="#2D4B95" dark v-if="nivelFilter && nivelFilter.length > 0" class="mr-4">
														{{ nivelFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="nivelFilter">
													<v-list-item dense style="min-height: auto;"
														v-for="(nivel, index) in configDataNivel"
														:key="'nivel_filter_' + index"
														:value="nivel.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ nivel.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Zona -->
										<v-expansion-panel>
											<v-expansion-panel-header style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;" class="py-2 px-3 mb-1">
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Zona</span>
													<v-chip x-small color="#2D4B95" dark v-if="zonaFilter && zonaFilter.length > 0" class="mr-4">
														{{ zonaFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="zonaFilter">
													<v-list-item dense style="min-height: auto;"
														v-for="(zona, index) in configDataZona"
														:key="'zona_filter_' + index"
														:value="zona.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ zona.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Ejes Alfabéticos Desde -->
										<v-expansion-panel>
											<v-expansion-panel-header style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;" class="py-2 px-3 mb-1">
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Ejes Alfabéticos — Desde</span>
													<v-chip x-small color="#2D4B95" dark v-if="ejeAFilter && ejeAFilter.length > 0" class="mr-4">
														{{ ejeAFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="ejeAFilter">
													<v-list-item dense style="min-height: auto;"
														v-for="(eje, index) in configDataEjeA"
														:key="'ejeA_filter_' + index"
														:value="eje.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ eje.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Ejes Alfabéticos Hasta -->
										<v-expansion-panel>
											<v-expansion-panel-header style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;" class="py-2 px-3 mb-1">
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Ejes Alfabéticos — Hasta</span>
													<v-chip x-small color="#2D4B95" dark v-if="ejeAToFilter && ejeAToFilter.length > 0" class="mr-4">
														{{ ejeAToFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="ejeAToFilter">
													<v-list-item dense style="min-height: auto;"
														v-for="(eje, index) in configDataEjeA"
														:key="'ejeA_to_filter_' + index"
														:value="eje.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ eje.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Ejes Numéricos Desde -->
										<v-expansion-panel>
											<v-expansion-panel-header style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;" class="py-2 px-3 mb-1">
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Ejes Numéricos — Desde</span>
													<v-chip x-small color="#2D4B95" dark v-if="ejeNFilter && ejeNFilter.length > 0" class="mr-4">
														{{ ejeNFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="ejeNFilter">
													<v-list-item dense style="min-height: auto;"
														v-for="(eje, index) in configDataEjeN"
														:key="'ejeN_filter_' + index"
														:value="eje.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ eje.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Ejes Numéricos Hasta -->
										<v-expansion-panel>
											<v-expansion-panel-header style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;" class="py-2 px-3 mb-1">
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Ejes Numéricos — Hasta</span>
													<v-chip x-small color="#2D4B95" dark v-if="ejeNToFilter && ejeNToFilter.length > 0" class="mr-4">
														{{ ejeNToFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="ejeNToFilter">
													<v-list-item dense style="min-height: auto;"
														v-for="(eje, index) in configDataEjeN"
														:key="'ejeN_to_filter_' + index"
														:value="eje.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ eje.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

									</v-expansion-panels>

									<v-btn x-small block color="#5e85ef" dark class="mt-2" @click="filterList()">
										<v-icon color="white" small class="mr-1">mdi-filter-outline</v-icon>
										<p class="mb-0 caption text-capitalize">Aplicar</p>
									</v-btn>
								</v-card-text>
							</v-card>
						</v-menu>
					</v-col>

          <!-- Col 3: Aprobaciones (expandida) -->
          <v-col cols="4" class="px-2">
            <v-btn text class="table-header-button d-flex flex-row pa-0 justify-start" block style="height: auto;" disabled>
              <p class="mb-0 font-weight-bold body-2 text-capitalize">Aprobaciones</p>
            </v-btn>
          </v-col>

          <!-- Col 5: Estado / Supervisor / Fechas -->
          <v-col cols="2">
            <v-menu v-model="statusMenu" :offset-y="true" :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  class="table-header-button d-flex flex-row pa-0 justify-start"
                  block
                  style="height: auto;"
                  v-bind="attrs"
                  v-on="on"
                >
                  <p class="mb-0 font-weight-bold body-2 text-capitalize">Estado</p>
                  <v-icon color="#5e85ef" small class="ml-1">mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <v-list dense class="filter-selector-list">
                <v-list-item dense style="min-height: auto;">
                  <div style="width: 100%" class="mb-1">
                    <p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Por Estado:</p>
                    <v-divider></v-divider>
                  </div>
                </v-list-item>
                <v-list-item-group multiple v-model="statusFilter">
                  <v-list-item
                    style="min-height: auto;"
                    v-for="(estado, index) in estadosEntrega"
                    :key="'e-' + index"
                    :value="estado.value"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-title class="my-0 d-flex flex-row align-center">
                        <v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
                        <p class="mb-0 caption">{{ estado.text }}</p>
                      </v-list-item-title>
                    </template>
                  </v-list-item>
                </v-list-item-group>

                <v-list-item dense style="min-height: auto;">
                  <div style="width: 100%" class="mt-2 mb-1">
                    <p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Por Supervisor:</p>
                    <v-divider></v-divider>
                  </div>
                </v-list-item>
                <v-list-item-group multiple v-model="supervisorFilter" v-if="$store.usersStore.state.usersList.length > 0">
                  <v-list-item
                    style="min-height: auto;"
                    v-for="(user, index) in supervisorsObjectList"
                    :key="'s-' + index"
                    :value="user.id"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-title class="my-0 d-flex flex-row align-center">
                        <v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
                        <p class="mb-0 caption">{{ user.name }}</p>
                      </v-list-item-title>
                    </template>
                  </v-list-item>
                </v-list-item-group>
                <div class="d-flex justify-center" style="width: 100%" v-else>
                  <v-progress-circular :size="20" :width="2" color="#2D4B95" indeterminate></v-progress-circular>
                </div>

                <v-list-item dense style="min-height: auto;">
                  <div style="width: 100%" class="mt-2 mb-1">
                    <p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Por Fecha Crítica:</p>
                    <v-divider></v-divider>
                  </div>
                </v-list-item>
                <v-list-item dense style="min-height: auto;">
                  <v-menu
                    v-model="fechaMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechaCriticaFilter"
                        label="Fecha crítica"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="fechaCriticaFilter" @input="fechaMenu = false"></v-date-picker>
                  </v-menu>
                </v-list-item>

                <v-list-item dense style="min-height: auto;">
                  <v-btn x-small block color="#5e85ef" dark class="mt-2" @click="filterList()">
                    <v-icon color="white" small class="mr-1">mdi-filter-outline</v-icon>
                    <p class="mb-0 caption text-capitalize">Aplicar</p>
                  </v-btn>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <!-- Col 6: Acciones -->
          <v-col cols="1">
            <v-btn text class="table-header-button d-flex flex-row pa-0 justify-end" block style="height: auto;" disabled>
              <p class="mb-0 font-weight-bold body-2 text-capitalize">Acciones</p>
            </v-btn>
          </v-col>

        </v-row>
      </v-card-text>
      <v-progress-linear
        v-if="$store.entregaStore.state.listadoEntrega.status === 99"
        class="listing-loading-bar"
        indeterminate
        color="#5e85ef"
      ></v-progress-linear>
    </v-card>

    <!-- MOBILE HEADER -->
    <v-card class="mb-2 py-1 listing-header-card hidden-sm-and-up">
      <v-card-text class="header-table-card py-2">
        <v-row no-gutters align="center">
          <v-col cols="10">
						<v-menu v-model="numeroMenuMobile" :offset-y="true" :close-on-content-click="false" max-height="620px">
							<template v-slot:activator="{ on, attrs }">
								<v-btn rounded color="#2D4B95" dark small block v-bind="attrs" v-on="on">
									<v-icon small class="mr-1">mdi-filter-variant</v-icon>
									Filtros
								</v-btn>
							</template>
							<v-list>

								<!-- Toggle orden -->
								<v-list-item>
									<v-btn
										class="custom-button-consultas d-flex flex-row align-center justify-space-between"
										block
										@click="toggleOrder"
									>
										<p class="mb-0 font-weight-bold body-2 text-capitalize">{{ getNameOrder }}</p>
										<v-icon color="#5e85ef" small>{{ getIconOrder }}</v-icon>
									</v-btn>
								</v-list-item>

								<!-- ── Nivel y Ejes con acordeones ── -->
								<v-list-item dense style="min-height: auto;">
									<div style="width: 100%" class="mt-1 mb-1">
										<p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Ubicación:</p>
										<v-divider></v-divider>
									</div>
								</v-list-item>
								<v-list-item dense style="min-height: auto; padding: 0 8px;">
									<v-expansion-panels accordion flat style="width: 100%;">

										<!-- Nivel -->
										<v-expansion-panel>
											<v-expansion-panel-header
												style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;"
												class="py-2 px-3 mb-1"
											>
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Nivel</span>
													<v-chip x-small color="#2D4B95" dark v-if="nivelFilter && nivelFilter.length > 0" class="mr-4">
														{{ nivelFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="nivelFilter">
													<v-list-item
														dense style="min-height: auto;"
														v-for="(nivel, index) in configDataNivel"
														:key="'m_nivel_filter_' + index"
														:value="nivel.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ nivel.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Zona -->
										<v-expansion-panel>
											<v-expansion-panel-header
												style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;"
												class="py-2 px-3 mb-1"
											>
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Zona</span>
													<v-chip x-small color="#2D4B95" dark v-if="zonaFilter && zonaFilter.length > 0" class="mr-4">
														{{ zonaFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="zonaFilter">
													<v-list-item
														dense style="min-height: auto;"
														v-for="(zona, index) in configDataZona"
														:key="'zona_filter_' + index"
														:value="zona.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ zona.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Ejes Alfabéticos Desde -->
										<v-expansion-panel>
											<v-expansion-panel-header
												style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;"
												class="py-2 px-3 mb-1"
											>
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Ejes Alfa — Desde</span>
													<v-chip x-small color="#2D4B95" dark v-if="ejeAFilter && ejeAFilter.length > 0" class="mr-4">
														{{ ejeAFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="ejeAFilter">
													<v-list-item
														dense style="min-height: auto;"
														v-for="(eje, index) in configDataEjeA"
														:key="'m_ejeA_filter_' + index"
														:value="eje.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ eje.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Ejes Alfabéticos Hasta -->
										<v-expansion-panel>
											<v-expansion-panel-header
												style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;"
												class="py-2 px-3 mb-1"
											>
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Ejes Alfa — Hasta</span>
													<v-chip x-small color="#2D4B95" dark v-if="ejeAToFilter && ejeAToFilter.length > 0" class="mr-4">
														{{ ejeAToFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="ejeAToFilter">
													<v-list-item
														dense style="min-height: auto;"
														v-for="(eje, index) in configDataEjeA"
														:key="'m_ejeA_to_filter_' + index"
														:value="eje.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ eje.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Ejes Numéricos Desde -->
										<v-expansion-panel>
											<v-expansion-panel-header
												style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;"
												class="py-2 px-3 mb-1"
											>
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Ejes Num — Desde</span>
													<v-chip x-small color="#2D4B95" dark v-if="ejeNFilter && ejeNFilter.length > 0" class="mr-4">
														{{ ejeNFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="ejeNFilter">
													<v-list-item
														dense style="min-height: auto;"
														v-for="(eje, index) in configDataEjeN"
														:key="'m_ejeN_filter_' + index"
														:value="eje.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ eje.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

										<!-- Ejes Numéricos Hasta -->
										<v-expansion-panel>
											<v-expansion-panel-header
												style="min-height: 36px; background-color: #eef2fb; border-radius: 6px;"
												class="py-2 px-3 mb-1"
											>
												<div class="d-flex align-center justify-space-between" style="width: 100%;">
													<span class="caption font-weight-bold text-primary-color">Ejes Num — Hasta</span>
													<v-chip x-small color="#2D4B95" dark v-if="ejeNToFilter && ejeNToFilter.length > 0" class="mr-4">
														{{ ejeNToFilter.length }}
													</v-chip>
												</div>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-list-item-group multiple v-model="ejeNToFilter">
													<v-list-item
														dense style="min-height: auto;"
														v-for="(eje, index) in configDataEjeN"
														:key="'m_ejeN_to_filter_' + index"
														:value="eje.value"
													>
														<template v-slot:default="{ active }">
															<v-list-item-title class="my-0 d-flex flex-row align-center">
																<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
																<p class="mb-0 caption">{{ eje.name }}</p>
															</v-list-item-title>
														</template>
													</v-list-item>
												</v-list-item-group>
											</v-expansion-panel-content>
										</v-expansion-panel>

									</v-expansion-panels>
								</v-list-item>

								<!-- Por Estado (sin cambios) -->
								<v-list-item dense style="min-height: auto;">
									<div style="width: 100%" class="mt-2 mb-1">
										<p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Por Estado:</p>
										<v-divider></v-divider>
									</div>
								</v-list-item>
								<v-list-item-group multiple v-model="statusFilter">
									<v-list-item
										style="min-height: auto;"
										v-for="(estado, idx) in estadosEntrega"
										:key="'me-' + idx"
										:value="estado.value"
									>
										<template v-slot:default="{ active }">
											<v-list-item-title class="my-0 d-flex flex-row align-center">
												<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
												<p class="mb-0 caption">{{ estado.text }}</p>
											</v-list-item-title>
										</template>
									</v-list-item>
								</v-list-item-group>

								<!-- Por Supervisor (sin cambios) -->
								<v-list-item dense style="min-height: auto;">
									<div style="width: 100%" class="mt-2 mb-1">
										<p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Por Supervisor:</p>
										<v-divider></v-divider>
									</div>
								</v-list-item>
								<v-list-item-group multiple v-model="supervisorFilter" v-if="$store.usersStore.state.usersList.length > 0">
									<v-list-item
										style="min-height: auto;"
										v-for="(user, idx) in supervisorsObjectList"
										:key="'ms-' + idx"
										:value="user.id"
									>
										<template v-slot:default="{ active }">
											<v-list-item-title class="my-0 d-flex flex-row align-center">
												<v-checkbox dense hide-details class="caption my-0 py-0" :input-value="active"></v-checkbox>
												<p class="mb-0 caption">{{ user.name }}</p>
											</v-list-item-title>
										</template>
									</v-list-item>
								</v-list-item-group>
								<div class="d-flex justify-center" style="width: 100%" v-else>
									<v-progress-circular :size="20" :width="2" color="#2D4B95" indeterminate></v-progress-circular>
								</div>

								<!-- Por Fecha Crítica (sin cambios) -->
								<v-list-item dense style="min-height: auto;">
									<div style="width: 100%" class="mt-2 mb-1">
										<p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Por Fecha Crítica:</p>
										<v-divider></v-divider>
									</div>
								</v-list-item>
								<v-list-item dense style="min-height: auto;">
									<v-menu
										v-model="fechaMenu"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="fechaCriticaFilter"
												label="Fecha crítica"
												prepend-icon="mdi-calendar"
												readonly
												v-bind="attrs"
												v-on="on"
												dense outlined
											></v-text-field>
										</template>
										<v-date-picker v-model="fechaCriticaFilter" @input="fechaMenu = false"></v-date-picker>
									</v-menu>
								</v-list-item>

								<!-- Aplicar -->
								<v-list-item dense style="min-height: auto;">
									<v-btn x-small block color="#5e85ef" dark class="mt-2" @click="filterList()">
										<v-icon color="white" small class="mr-1">mdi-filter-outline</v-icon>
										<p class="mb-0 caption text-capitalize">Aplicar</p>
									</v-btn>
								</v-list-item>

							</v-list>
						</v-menu>
          </v-col>
          <v-col cols="2">
            <div class="d-flex flex-row justify-end align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="icon-top total mobile" v-bind="attrs" v-on="on">
                    <span class="white--text caption">{{
                      $store.entregaStore.state.listadoEntrega.total_entrega
                    }}</span>
                  </div>
                </template>
                <span>Total de Entregas</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
        <div class="d-flex align-center flex-wrap mt-4" style="gap: 8px;">
          <v-btn block dark x-small color="#2D4B95" @click="$store.entregaStore.commit('setEntregaConfigModal', true)">
            <v-icon small class="mr-1">mdi-cog</v-icon>
            <p class="mb-0">Configurar</p>
          </v-btn>
          <v-btn block dark x-small color="#2D4B95" :loading="loadingExport" :disabled="loadingExport" @click="excelExport()">
            <v-icon small class="mr-1">mdi-microsoft-excel</v-icon>
            <p class="mb-0">Exportar</p>
          </v-btn>
        </div>
      </v-card-text>
      <v-progress-linear
        v-if="$store.entregaStore.state.listadoEntrega.status === 99"
        class="listing-loading-bar"
        indeterminate
        color="#5e85ef"
      ></v-progress-linear>
    </v-card>

    <!-- ══════════════════════════════════════════════════════
         LISTA DE ENTREGAS
         ══════════════════════════════════════════════════════ -->
    <div
      v-if="$store.entregaStore.state.listadoEntrega.status === 1"
      class="listing-scroll"
    >

      <!-- DESKTOP: usa EntregaRow (comportamiento original) -->
      <template v-if="!$vuetify.breakpoint.xs">
        <EntregaRow
          v-for="(entrega, index) in $store.entregaStore.state.listadoEntrega.data"
          :key="'d-' + index"
          :entrega="entrega"
          :active-aprobadores="getActiveAprobadores()"
          :planos="planos"
          :config-data="configData"
          :zonas-list="zonasList"
          :is-loading-visualization="isLoadingChangeVisualizationStatus(entrega.id)"
          @view="viewEntrega(entrega.id, $options.filters.seenByMe(entrega.seen_by_me))"
          @edit="editEntrega(entrega)"
          @change-visualization="changeVisualizationStatus(entrega)"
        />
      </template>

      <!-- MOBILE: usa EntregaRow con modo mobile -->
      <template v-else>
        <EntregaRow
          v-for="(entrega, index) in $store.entregaStore.state.listadoEntrega.data || []"
          :key="'m-' + index"
          :entrega="entrega"
          :mobile="true"
          :active-aprobadores="getActiveAprobadores()"
          :planos="planos"
          :config-data="configData"
          :zonas-list="zonasList"
          :is-loading-visualization="isLoadingChangeVisualizationStatus(entrega.id)"
          @view="viewEntrega(entrega.id, $options.filters.seenByMe(entrega.seen_by_me))"
          @edit="editEntrega(entrega)"
          @change-visualization="changeVisualizationStatus(entrega)"
        />
      </template>

      <!-- Paginación (compartida) -->
      <v-row align="center" v-if="$store.entregaStore.state.listadoEntrega.count > 0">
        <v-col cols="12">
          <v-pagination
            v-model="page"
            color="#2D4B95"
            :length="Math.ceil($store.entregaStore.state.listadoEntregaTotal / 50)"
            :total-visible="7"
            @input="changePage"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>

    <!-- Skeletons de carga -->
    <div v-else>
      <!-- Desktop skeletons -->
      <template v-if="!$vuetify.breakpoint.xs">
        <v-card class="mb-2 py-2" v-for="i in 5" :key="'ds-' + i">
          <v-card-text class="py-2">
            <v-row no-gutters align="center">
              <v-col cols="1"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader></v-col>
              <v-col cols="3"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item-two-line"></v-skeleton-loader></v-col>
              <v-col cols="2"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader></v-col>
              <v-col cols="3"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader></v-col>
              <v-col cols="2"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item-two-line"></v-skeleton-loader></v-col>
              <v-col cols="1"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <!-- Mobile skeletons -->
      <template v-else>
        <v-card class="mb-2 py-2" v-for="i in 5" :key="'ms-' + i">
          <v-card-text class="py-2">
            <v-row>
              <v-col cols="4"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader></v-col>
              <v-col cols="8"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item-two-line"></v-skeleton-loader></v-col>
              <v-col cols="6"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader></v-col>
              <v-col cols="6"><v-skeleton-loader class="mx-auto" min-width="100%" type="list-item-two-line"></v-skeleton-loader></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </div>

    <!-- ══════════════════════════════════════════════════════
         PANELES Y DIÁLOGOS (sin cambios)
         ══════════════════════════════════════════════════════ -->

    <!-- Status Description Panel -->
    <div class="status-description-panel mt-3" v-if="selectedStatusDescription">
      <v-card flat>
        <v-card-text class="py-2">
          <v-row align="center">
            <v-col cols="12">
              <div class="d-flex align-center">
                <v-chip small :color="selectedStatusColor" class="mr-2">
                  {{ selectedStatusText }}
                </v-chip>
                <span class="status-description">{{ selectedStatusDescription }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <!-- Referential Plan Dialog -->
    <v-dialog v-model="planDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline">
          Plano Referencial
          <v-spacer></v-spacer>
          <v-btn icon @click="planDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="plan-container">
            <img :src="currentPlanUrl" alt="Plano Referencial" class="plan-image" v-if="currentPlanUrl" />
            <div class="text-center py-5" v-else>
              <p>No hay plano referencial disponible para este elemento.</p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Edit Entrega Modal -->
    <EditEntregaModal
      v-model="editEntregaModal"
      :entregaData="selectedEntrega"
      @update-success="handleEntregaUpdated"
    />
  </v-container>
</template>

<script>
import moment from "moment";
import EntregaRow from "./EntregaRow.vue";
import EditEntregaModal from "../../Globals/Modals/Entrega/EditEntregaModal.vue";
import { checkPermissions } from "@/helpers/permissions";
import { getEntregaByID, getConfig, getPlano, changeVisualizationStatus } from "@/helpers/api/entrega";
import { getJobTypes } from "@/helpers/api/user";
import { exportStatusEntregaByProject } from "@/helpers/api/exports";

export default {
  name: "ListadoEntregas",
  components: { EntregaRow, EditEntregaModal },
  props: {
    ended: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      specialtyFilter: [],
      specialtyMenu: false,
      subjectFilter: [],
      subjectMenu: false,
      responsableFilter: [],
      responsableMenu: false,
      page: 1,
      nivelFilter: "",
			zonaFilter: "",
			ejeAFilter: "",
			ejeAToFilter: "",
			ejeNFilter: "",
			ejeNToFilter: "",
      supervisorFilter: [],
      statusFilter: [],
      fechaCriticaFilter: [],
      numeroMenu: false,
			numeroMenuMobile: false,
      nivelMenu: false,
      statusMenu: false,
      supervisorMenu: false,
      fechaCriticaMenu: false,
      fechaMenu: false,
      loadingExport: false,
      orderBy: "desc",
      orderByField: "created_at",
      taskDetailDialog: false,
      selectedTask: null,
      editEntregaModal: false,
      selectedEntrega: null,
      estadosEntrega: [
        { value: 1, text: "Preparado" },
        { value: 2, text: "En Revisión" },
        { value: 3, text: "Aprobado" },
        { value: 4, text: "Cerrado" },
      ],
      planDialog: false,
      currentPlanUrl: null,
      selectedStatusDescription: null,
      selectedStatusText: null,
      selectedStatusColor: null,
      statusDescriptions: {
        preparado: "Entrega fue creada en el sistema",
        revision:
          "Inicia el proceso de checkear. Se marcan en naranja, al usuario, el cual ya se inició el proceso de revisión. Se marca en verde al usuario que realizó la revisión completa del protocolo y realizó todos los checks",
        aprobado:
          "Se completó el proceso de check, de acuerdo con la aprobación mínima requerida",
        cerrado:
          "Registro final de firmas electrónica simple. Para dar un cierre administrativo a la entrega, se realiza este proceso en donde al menos debería firmar 2 usuarios (o los que se requiera). En este proceso debería realizarse, luego de la aprobación y una vez que se hayan levantado todas las observaciones plasmadas al interior de la entrega (aprobado con observación) si es que la hubiese",
      },
    };
  },

  computed: {
    zonasList() {
      const config = this.$store.entregaStore.state.config || {};
      return (config.zonas || []).map(zona => ({
        id: zona.id,
        name: zona.name,
        niveles: zona.niveles || [],
        ejesAlfabeticos: zona.ejesAlfabeticos || [],
        ejesNumericos: zona.ejesNumericos || [],
      }));
    },
    configData() {
      return this.$store.entregaStore.state.config || { aprobadores: [] };
    },
    configDataNivel() {
			if(this.configData?.niveles){
				return this.configData.niveles.map(nivel => ({
					value: nivel,
					name: nivel,
				}));
			}
      return [];
    },
    configDataZona() {
			if(this.configData?.zonas){
				return this.configData.zonas.map(zona => ({
					value: zona.id,
					name: zona.name,
				}));
			}
      return [];
    },
    configDataEjeA() {
			if(this.configData?.ejesAlfabeticos){
				return this.configData.ejesAlfabeticos.map(eje => ({
					value: eje,
					name: eje,
				}));
			}
      return [];
    },
		configDataEjeN() {
			if(this.configData?.ejesNumericos){
				return this.configData.ejesNumericos.map(eje => ({
					value: eje,
					name: eje,
				}));
			}
      return [];
    },
    minApprovers() {
      const config = this.$store.entregaStore.state.config || {};
      return config.minimo || 0;
    },
    selectedProject() {
      return this.$store.projectsStore.state.selectedProject;
    },
    planos() {
      return this.$store.entregaStore.state.planos.data || [];
    },
    getIconOrder() {
      if (this.$store.entregaStore && this.$store.entregaStore.state) {
        const order = this.$store.entregaStore.state.listingOrder;
        if (order === 1 || order === 3) return "mdi-arrow-down-bold";
        if (order === 2 || order === 4) return "mdi-arrow-up-bold";
      }
      return "mdi-swap-vertical-bold";
    },
    getNameOrder() {
      if (this.$store.entregaStore && this.$store.entregaStore.state) {
        const order = this.$store.entregaStore.state.listingOrder;
        if (order === 1 || order === 2) return "Prioridad";
        if (order === 3 || order === 4) return "Número";
      }
      return "Orden";
    },
    supervisorsList() {
      return this.$store.entregaStore.state.listadoEntrega?.data?.reduce((acc, entrega) => {
        if (entrega.supervisor_id && !acc.includes(entrega.supervisor_id)) {
          acc.push(entrega.supervisor_id);
        }
        return acc;
      }, []);
    },
    supervisorsObjectList() {
      return this.supervisorsList
        ?.map(id => this.$store.usersStore.state?.usersList?.find(user => user.id == id))
        .filter(i => i);
    },
  },

  filters: {
    seenByMe(seen) { return !!seen; },
    seenByMeColor(seen) { return seen ? "normal" : "high"; },
    seenByMeIconAnimation(seen) { return seen ? "" : "pulse"; },
    seenByMeText(seen) { return seen ? "Leído" : "No leído"; },
    toDate(date, format) {
      if (!date) return "";
      return moment(date).format(format || "DD/MM/YYYY");
    },
    toHour(date) {
      if (!date) return "";
      return moment(date).format("HH:mm");
    },
  },

  watch: {
    selectedProject(newData) {
      if (newData) {
        this.getProjectSubjects();
        this.reloadData();
      }
    },
    ended() {
      this.reloadData();
    },
  },

  async mounted() {
    if (this.$store.projectsStore.state.projectSubjects.length === 0) {
      this.getProjectSubjects();
    }
    if (this.selectedProject) {
      this.reloadData();
    }
  },

  methods: {
    async reloadData() {
      const projectID = this.selectedProject ? this.selectedProject.id : null;
      if (projectID) {
        this.$store.entregaStore.dispatch("getPlanos", { project_id: projectID });
        const [configResponse, jobTypesResponse] = await Promise.all([
          getConfig({ project_id: projectID }),
          getJobTypes({ project_id: projectID }),
        ]);
        this.$store.usersStore.commit("setJobTypes", jobTypesResponse.job_types);
        this.$store.entregaStore.commit("setConfig", configResponse.config);
        this.getEntregaList();
      }
    },

    zonaName(id) {
      const zona = this.zonasList.find(z => z.id === id);
      return zona ? zona.name : "";
    },

    editEntrega(entrega) {
      this.selectedEntrega = { ...entrega };
      this.editEntregaModal = true;
    },

    handleEntregaUpdated() {
      this.getEntregaList();
    },

    checkPermissions: checkPermissions,

    isLoadingChangeVisualizationStatus(entregaId) {
      return this.$store.entregaStore.state.loadingChangeVisualizationStatus.includes(entregaId);
    },

    async viewReferentialPlan() {
      try {
        if (this.planos.length === 0) {
          const planoResponse = await getPlano({ project_id: this.selectedProject.id });
          if (planoResponse.code === 200) {
            this.planos = planoResponse.planos;
          }
        }
        if (this.$refs.planoViewerRef) {
          this.$refs.planoViewerRef.openModal();
        }
      } catch (error) {
        console.error("Error fetching plano:", error);
        this.$toast.error("No se pudo cargar el plano referencial");
      }
    },

    getActiveAprobadores() {
			return this.$store.usersStore.state.jobTypes.filter(jobType =>
				this.$store.entregaStore.state.config.aprobadores.some(
					aprobador => Number(aprobador.id) === jobType.id
				)
			);
		},

    // ── Helpers originales ──────────────────────────────────────────────────
    setLights(data) {
      return require("@/assets/Svg/VistaListado/Semaforo" + data + ".svg");
    },

    async getProjectSubjects() {
      if (this.selectedProject && this.selectedProject.id) {
        this.$store.projectsStore.dispatch("getProjectSubjects", this.selectedProject.id);
      }
    },

    toggleOrder() {
      if (this.$store.entregaStore) {
        this.$store.entregaStore.commit("setListingOrder");
        this.getEntregaList();
      }
    },

    async getEntregaList() {
      let projectId = null;
      const page = this.page;
      if (this.selectedProject) {
        projectId = this.selectedProject.id;
      } else {
        const id = localStorage.getItem("selectedProjectID");
        projectId = parseInt(id);
      }
      if (projectId && this.$store.entregaStore) {
        const filters = {
          project_id: projectId,
          page,
          filtered_specialties: this.specialtyFilter,
          filtered_subjects: this.subjectFilter,
          filtered_responsable: this.responsableFilter,
        };
        if (this.numeroFilter) filters.numero_id = this.numeroFilter;
        if (this.nivelFilter) filters.nivel = this.nivelFilter;
        if (this.zonaFilter) filters.zona = this.zonaFilter;
        if (this.supervisorFilter && this.supervisorFilter.length > 0) filters.supervisor_ids = this.supervisorFilter;
        if (this.statusFilter && this.statusFilter.length > 0) filters.estados = this.statusFilter;
        if (this.fechaCriticaFilter) filters.fecha_critica = this.fechaCriticaFilter;

				if (this.ejeAFilter) filters.ejes_alfabeticos = this.ejeAFilter;
				if (this.ejeAToFilter) filters.ejes_alfabeticos_b = this.ejeAToFilter;
				if (this.ejeNFilter) filters.ejes_numericos = this.ejeNFilter;
				if (this.ejeNToFilter) filters.ejes_numericos_b = this.ejeNToFilter;

        this.$store.entregaStore.dispatch("getEntrega", filters);
      }
    },

    filterList() {
      this.getEntregaList();
      this.specialtyMenu = false;
      this.subjectMenu = false;
      this.responsableMenu = false;
      this.numeroMenu = false;
			this.numeroMenuMobile = false;
      this.nivelMenu = false;
      this.supervisorMenu = false;
      this.statusMenu = false;
      this.fechaCriticaMenu = false;
      this.fechaMenu = false;
    },

    async excelExport() {
      this.loadingExport = true;
      const data = {
        project_id: this.$store.projectsStore.state.selectedProject.id,
      };
      const exportEntrega = await exportStatusEntregaByProject(data);
      if (exportEntrega.code == 200) {
        window.open(exportEntrega.url);
      }
      this.loadingExport = false;
    },

    async viewEntrega(entregaId, seenByMe) {
      if (!this.selectedProject) return;
      const projectID = this.selectedProject.id;
      this.$store.entregaStore.commit("setCurrentEntrega", { loading: true });
      try {
        const entregaResponse = await getEntregaByID({ entrega_id: entregaId });
        const [configResponse, jobTypesResponse] = await Promise.all([
          getConfig({ project_id: projectID }),
          getJobTypes({ project_id: projectID }),
        ]);
        this.$store.usersStore.commit("setJobTypes", jobTypesResponse.job_types);
        this.$store.entregaStore.commit("setConfig", configResponse.config);
        if (entregaResponse.code === 403) {
          this.$store.entregaStore.commit("setCurrentEntrega", null);
        } else if (entregaResponse.code === 200) {
          const entregaData = entregaResponse.entrega;
          entregaData.prev_seen_by_me = seenByMe;
          this.$store.entregaStore.commit("setCurrentEntrega", entregaData);
          this.setStatusDescription(entregaData);
        }
      } catch (error) {
        console.error("Error loading entrega details:", error);
        this.$store.entregaStore.commit("setCurrentEntrega", { loading: false, error: true });
      }
    },

    changePage() {
      this.getEntregaList();
    },



    setStatusDescription(entrega) {
      if (!entrega) return;
      const statusMap = { 0: "preparado", 1: "revision", 2: "aprobado", 3: "cerrado" };
      const innerStatus = entrega.status_info.status;
      const status = statusMap[innerStatus] || "preparado";
      this.selectedStatusDescription = this.statusDescriptions[status];
      this.selectedStatusText = entrega.status_info.text;
      this.selectedStatusColor = entrega.status_info.color;
    },

    async changeVisualizationStatus(entrega) {
      const current = Number(entrega.seen_by_me?.seen_status ?? entrega.seen_status ?? 0);
      const status = current === 0 ? 1 : current === 1 ? 2 : 0;
      this.$store.entregaStore.commit("addLoadingChangeVisualizationStatus", entrega.id);
      try {
        const response = await changeVisualizationStatus({ entrega_id: entrega.id, status });
        if (response.code === 200) {
          this.$set(entrega, "seen_by_me", { ...(entrega.seen_by_me || {}), seen_status: status });
        }
      } finally {
        this.$store.entregaStore.commit("removeLoadingChangeVisualizationStatus", entrega.id);
      }
    },
  },
};
</script>

<style>
#listado-entregas {
  align-self: stretch;
}

/* ── Tipografía y colores base ── */
.text-primary-color { color: #2d4b95; }
.light-blue-text    { color: #5e85ef; }
.bg-normal          { background-color: #3ebfa3; }
.text-white         { color: #fff !important; }

/* ── Íconos de estado ── */
.icon-top {
  padding: 2px;
  margin: 0 2px;
  border-radius: 100%;
}
.icon-top.high    { background-color: #f4516c; }
.icon-top.medium  { background-color: #fb8c00; }
.icon-top.normal  { background-color: #3ebfa3; }
.icon-top.primary { background-color: #2d4b95; }
.icon-top.light-blue { background-color: #5e85ef; }
.icon-top.number {
  background-color: #2d4b95;
  text-align: center;
  line-height: 20px;
	width: 35px;
	max-width: 35px;
	border-radius: 5px;
}
.icon-top.total{
	background-color: white;
	text-align: center;
	border-radius: 5px!important;
	border: 1px solid #2D4B95;
	font-size: 10px;
	color: #2D4B95;
	font-weight: bold;
}
.icon-top.total.mobile {
  background-color: #5e85ef;
  text-align: center;
  line-height: 20px;
  padding: 2px 5px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
}
.high   { color: #f4516c; }
.medium { color: #fb8c00; }
.normal { color: #3ebfa3; }

/* ── Contenedor de íconos ── */
.icon-container { flex-wrap: wrap; }
.icon-container .icon-top {
  flex: 1 0 30%;
  width: 24px; max-width: 24px;
  height: 24px; max-height: 24px;
  margin-bottom: 2px;
}
.text-task-number.caption { font-size: 10px !important; }

/* ── Cards ── */
.tarea-card {
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;
}
.tarea-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,.1);
}

/* ── Header fijo ── */
.listing-header-card {
  position: sticky;
  top: 0;
  z-index: 2;
  background: white;
}
.listing-loading-bar { position: absolute; bottom: 0; }
.header-table-card { border: 1px solid white; }

/deep/ .header-table-card .table-header-button:hover:before { opacity: 0; }

/* ── Incógnito ── */
.incognito-container {
  width: 0; height: 0;
  border-top: 33px solid #616161;
  border-right: 33px solid transparent;
  border-radius: 0 !important;
  position: absolute; left: 0;
}
.incognito-container .v-icon {
  position: absolute;
  top: -32px; left: 1px;
}

/* ── Deadline ── */
.near-deadline { background-color: #fb8c00; }

/* ── Panel de estado ── */
.status-description-panel {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,.1);
}
.status-description { font-size: .9rem; color: rgba(0,0,0,.7); }

/* ── Plano ── */
.plan-container {
  width: 100%;
  max-height: 500px;
  overflow: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.plan-image { width: 100%; height: auto; display: block; }

/* ── Texto con ellipsis ── */
.text-tarea-field {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 50px;
}
/deep/ .text-tarea-field h1,
/deep/ .text-tarea-field h2,
/deep/ .text-tarea-field h3 { font-size: 1em !important; }

/* ── Mobile: badges de aprobación ── */
.entrega-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 2px 3px;
  width: calc(33.33% - 2px);
  box-sizing: border-box;
  cursor: pointer;
}
.entrega-badge-label {
  font-size: 9px;
  color: grey;
  margin-top: 1px;
  line-height: 1.1;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Mobile: tooltip aprobaciones ── */
.approval-tooltip-content  { padding: 6px 4px; color: #333; }
.approval-tooltip-header   { font-size: 12px; font-weight: 600; margin-bottom: 4px; border-bottom: 1px solid #e8edf8; padding-bottom: 4px; }
.approval-tooltip-row      { margin-top: 4px; font-size: 11px; }
.approval-tooltip-task     { font-weight: 500; color: #444; }
.approval-tooltip-meta     { color: #666; margin-left: 4px; }
.approval-tooltip-comment  { font-style: italic; }
.approval-tooltip-empty    { font-size: 11px; color: #9e9e9e; font-style: italic; }

/* ── Mobile: botón de filtros ── */
.custom-button-consultas.v-btn {
  background-color: white;
  color: #2d4b95;
  opacity: 1 !important;
}
/deep/ .custom-button-consultas.v-btn .v-icon,
/deep/ .custom-button-consultas.v-btn p { color: #2d4b95 !important; font-size: 13px; }
/deep/ .custom-button-consultas.v-btn .v-icon { font-size: 20px; }
/deep/ .custom-button-consultas.v-btn:hover .v-icon,
/deep/ .custom-button-consultas.v-btn:hover p,
/deep/ .custom-button-consultas.v-btn.selected .v-icon,
/deep/ .custom-button-consultas.v-btn.selected p { color: white !important; }
.custom-button-consultas.selected,
.custom-button-consultas:hover { background-color: #2d4b95 !important; }

/* ── Animación pulse ── */
.pulse { animation: pulse-animation 2s infinite; }
@keyframes pulse-animation {
  0%   { transform: scale(.95); opacity: .7; }
  50%  { transform: scale(1.1); opacity: 1;  }
  100% { transform: scale(.95); opacity: .7; }
}

/* ── Misc ── */
.adough {
  width: 30%; min-width: 60px; margin: 2px 2px 5px;
  position: relative; display: flex;
  justify-content: center; align-items: center;
}
.status-icon { border: 1px solid #5e85ef; border-radius: 100%; }
/deep/ .status-icon .inner {
  border: 1px solid #f2f2f2; border-radius: 100%;
  width: 14px; height: 14px;
}
/deep/ .status-icon .inner.danger { background-color: #f4516c; }
.float-total-icon { position: absolute; top: 0; right: 5px; bottom: 0; }
</style>